const DEFAULT_SERVICE_TYPE_LABEL = 'Sin especificar'

const VEHICLE_SERVICE_TYPE_MAP = {
  particular: 'Particular',
  publico: 'Público',
};

export const getVehicleServiceTypeDisplay = (serviceType) => {
  if (typeof serviceType !== 'string') return DEFAULT_SERVICE_TYPE_LABEL;
  const key = serviceType.toLowerCase();
  return VEHICLE_SERVICE_TYPE_MAP[key] ?? DEFAULT_SERVICE_TYPE_LABEL;
};